import { ChangeEvent, useMemo, useState } from "react";
import { FormikProps, useFormik } from "formik";
import { useGetHqActivities } from "src/features/hq/manage/components/UserActivities/hooks";
import { CxActivityHistoryPresenter } from "./CxActivityHistoryPresenter";
import { useGetCustomerCxActivitiesAPI, usePutCustomerCxActivitiesAPI } from "../../../hq-customers.api";
import { useParams } from "react-router-dom";
import { CxActivity } from "../../../models";

export type EditForm = {
  cxActivities: CxActivity[];
};

export function CxActivityHistoryContainer() {
  const { id: userId } = useParams();
  const [editing, setEditing] = useState(false);
  const { data: activities, isLoading: activitiesLoading } = useGetHqActivities();
  const { data: cxActivities, isLoading: cxActivitiesLoading } = useGetCustomerCxActivitiesAPI(userId as string)
  const { mutate } = usePutCustomerCxActivitiesAPI(userId as string);

  const submitUpdates = (updates: EditForm) => {
    mutate(updates.cxActivities.filter(cx => !!cx.activityName));
  };

  const sortedActivities = useMemo(() => cxActivities?.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()), [cxActivities]);

  const formik: FormikProps<EditForm> = useFormik<EditForm>({
    initialValues: {
      cxActivities: sortedActivities ?? []
    },
    onSubmit: submitUpdates,
    enableReinitialize: true,
  });

  const handeChange = (index: number, property: string) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      const updatedActivities = formik.values.cxActivities;
      formik.setFieldValue('cxActivities', updatedActivities.map((m, i) => {
        if (i === index) {
          return {
            ...m,
            [property]: event.target.value
          }
        }
        return m;
      }));
    }

  const addActivity = () => {
    const newActivities = [...formik.values.cxActivities, {
      date: (new Date()).toISOString(),
      activity: '',
      note: ''
     }];
    formik.setFieldValue('cxActivities', newActivities);
  }

  const removeActivity = (index: number) => {
    const newActivities = formik.values.cxActivities.filter((_, i) => i !== index);
    formik.setFieldValue('cxActivities', newActivities);
  }

  const toggleEditing = (isEditing: boolean) => {
    if (isEditing) {
      addActivity();
    }

    setEditing(isEditing);
  }

  return <CxActivityHistoryPresenter
    editing={editing}
    formik={formik}
    handeChange={handeChange}
    setEditing={toggleEditing}
    isLoading={activitiesLoading || cxActivitiesLoading}
    addActivity={addActivity}
    handleRemoveMember={removeActivity}
    activities={activities}
  />
}
